<hr class="topSeparator" *ngIf="topSeparator" />

<ion-button type="button" fill="clear" class="button">
  <a *ngIf="href; else buttonTemplate" href="{{ href }}" target="_blank">
    <div class="imageCont">
      <img
        [src]="sanitizer.bypassSecurityTrustResourceUrl(image)"
        (load)="hideFallbackIcon()"
        (error)="setToFallbackIcon()"
        *ngIf="image; else iconTemplate" />

      <ng-template #iconTemplate>
        <span class="{{ icon }}"></span>
      </ng-template>

      <span *ngIf="fallbackIcon" class="{{ fallbackIcon }} placeholder"></span>
    </div>

    <div class="buttonTextCont">
      <p class="buttonText">{{ buttonText }}</p>
    </div>
  </a>

  <ng-template #buttonTemplate>
    <div class="innerButton">
      <div class="imageCont">
        <img
          [src]="sanitizer.bypassSecurityTrustResourceUrl(image)"
          (error)="setToFallbackIcon()"
          *ngIf="image; else iconTemplate" />

        <ng-template #iconTemplate>
          <span class="{{ icon }}"></span>
        </ng-template>

        <span *ngIf="fallbackIcon" class="{{ fallbackIcon }} placeholder"></span>
      </div>

      <div class="buttonTextCont">
        <p class="buttonText">{{ buttonText }}</p>
      </div>
    </div>
  </ng-template>

  <div class="chevron" *ngIf="chevron">
    <ion-icon src="/assets/icon/chevron-right-icon.svg"></ion-icon>
  </div>
</ion-button>

<hr class="bottomSeparator" *ngIf="bottomSeparator" />
